/** GraphRAG controls (M28, GR-G1-4): mirror of the backend `app/core/constants/graph_controls.py`,
 *  the flag and budget keys of `graph.py` and the per-plan budget of `plans.py`.
 *  `backend/tests/core/test_graph_controls_mirror.py` keeps the two equal. */

/** The plan feature, the per-workspace switch and the agent setting share this key. */
export const GRAPH_RETRIEVAL_KEY = "graph_retrieval" as const;
/** Platform flag (layer 1); off means no extraction and no graph branch. */
export const GRAPH_FLAG_KEY = "graphrag_experiment" as const;
/** The monthly extraction budget key: a plan limit and a `tenants.overrides.limits` key. */
export const GRAPH_MONTHLY_CHUNKS_KEY = "graph_monthly_chunks" as const;

export const GRAPH_RETRIEVAL_MODE_VALUES = ["off", "assist"] as const;
export type GraphRetrievalMode = (typeof GRAPH_RETRIEVAL_MODE_VALUES)[number];
export const DEFAULT_GRAPH_RETRIEVAL_MODE = "off" as const;

export const GRAPH_LAYER_VALUES = ["platform_flag", "plan", "tenant_override", "agent"] as const;
export type GraphLayer = (typeof GRAPH_LAYER_VALUES)[number];

export const TENANT_GRAPH_SWITCH_VALUES = ["inherit", "on", "off"] as const;
export type TenantGraphSwitch = (typeof TENANT_GRAPH_SWITCH_VALUES)[number];

/** Seconds between two admin rebuild requests for one workspace. */
export const GRAPH_REBUILD_COOLDOWN_SECONDS = 300 as const;

/** Chunks per month the extraction may process (0 = none), by plan. */
export const GRAPH_MONTHLY_CHUNKS_BY_PLAN = {
  starter: 0,
  standard: 0,
  pro: 20000,
  institution: 100000,
} as const;
